import React from "react"

const Banner = ({ text, cta }) => (
  <div className="banner">
    {text}
    {cta}
  </div>
)

export default Banner
